import React, { useState } from "react";
import { Badge, Button } from "react-bootstrap";

const SelectFrame = () => {
    const [selectedFrame, setSelectedFrame] = useState(null);

    const frames = [
        {
            id: 1,
            name: 'Facebook Post Frame',
            platform: 'Facebook',
            color: '#1877f2',
            preview: 'https://scontent.fbpm6-1.fna.fbcdn.net/v/t39.30808-6/475332448_122188866182188380_3614891003529038204_n.jpg?stp=dst-jpg_s960x960_tt6&_nc_cat=107&ccb=1-7&_nc_sid=127cfc&_nc_ohc=wvQCw549BSwQ7kNvwGxkegs&_nc_oc=Adn-OBpBJpaSt39cytjJP3rJbw3e11muS8fgDC-_h_s3K_fMgIzuIwTCZQRvrS3e1bo&_nc_zt=23&_nc_ht=scontent.fbpm6-1.fna&_nc_gid=3VYHJ-uB4MnHH2CFMeZAOQ&oh=00_AfG5ZcDxB7JS_ZcL8Z_CBWQXU7ArW6_mK_D1U4bxXDHFuw&oe=680D7929',
            description: 'Standard Facebook post template'
        },
        {
            id: 2,
            name: 'Instagram Story Frame',
            platform: 'Instagram',
            color: '#e4405f',
            preview: 'https://via.placeholder.com/400x600/e4405f/ffffff?text=Instagram+Story',
            description: 'Vertical Instagram story template'
        },
        {
            id: 3,
            name: 'Twitter Post Frame',
            platform: 'Twitter',
            color: '#1da1f2',
            preview: 'https://via.placeholder.com/600x400/1da1f2/ffffff?text=Twitter+Post',
            description: 'Twitter post template'
        },
        {
            id: 4,
            name: 'LinkedIn Post Frame',
            platform: 'LinkedIn',
            color: '#0077b5',
            preview: 'https://via.placeholder.com/600x400/0077b5/ffffff?text=LinkedIn+Post',
            description: 'Professional LinkedIn post template'
        },
        {
            id: 5,
            name: 'YouTube Thumbnail',
            platform: 'YouTube',
            color: '#ff0000',
            preview: 'https://via.placeholder.com/1280x720/ff0000/ffffff?text=YouTube+Thumbnail',
            description: 'YouTube video thumbnail template'
        },
        {
            id: 6,
            name: 'Pinterest Pin Frame',
            platform: 'Pinterest',
            color: '#bd081c',
            preview: 'https://via.placeholder.com/400x600/bd081c/ffffff?text=Pinterest+Pin',
            description: 'Vertical Pinterest pin template'
        }
    ];

    const handleSelectFrame = (frameId) => {
        setSelectedFrame(frameId);
    };

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <div>
                        <h5 className="mb-1 font-weight-bold">Select Frame Template</h5>
                        <small className="text-muted">Choose a template for your social media posts</small>
                    </div>
                    <Badge bg="primary" style={{ background: 'var(--themecolor)', fontSize: '14px', padding: '8px 16px' }}>
                        {frames.length} Templates
                    </Badge>
                </div>

                {/* Frames Grid - 2 Columns for Bigger Cards */}
                <div className="row">
                    {frames.map((frame) => (
                        <div key={frame.id} className="col-12 col-lg-6 mb-4">
                            <div
                                className="card h-100"
                                style={{
                                    border: selectedFrame === frame.id ? '3px solid var(--themecolor)' : '1px solid #e8e8e8',
                                    borderRadius: '10px',
                                    boxShadow: selectedFrame === frame.id ? '0 8px 20px rgba(102, 126, 234, 0.3)' : '0 2px 8px rgba(0,0,0,0.06)',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    transform: selectedFrame === frame.id ? 'scale(1.02)' : 'scale(1)'
                                }}
                                onClick={() => handleSelectFrame(frame.id)}
                                onMouseEnter={(e) => {
                                    if (selectedFrame !== frame.id) {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.12)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (selectedFrame !== frame.id) {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
                                    } else {
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                    }
                                }}
                            >
                                {/* Selected Overlay with Big Checkmark */}
                                {selectedFrame === frame.id && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: 'rgba(102, 126, 234, 0.15)',
                                        zIndex: 5,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        pointerEvents: 'none'
                                    }}>
                                        <div style={{
                                            width: '100px',
                                            height: '100px',
                                            borderRadius: '50%',
                                            background: 'var(--themecolor)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                                        }}>
                                            <i className="fa fa-check" style={{
                                                fontSize: '50px',
                                                color: '#fff'
                                            }}></i>
                                        </div>
                                    </div>
                                )}

                                {/* Platform Badge - Right Side (when not selected) or Selected Badge */}
                                <div style={{
                                    position: 'absolute',
                                    top: '20px',
                                    right: '20px',
                                    background: selectedFrame === frame.id ? 'var(--themecolor)' : frame.color,
                                    color: '#fff',
                                    padding: '10px 20px',
                                    borderRadius: '25px',
                                    fontSize: '15px',
                                    fontWeight: '700',
                                    zIndex: 10,
                                    textTransform: selectedFrame === frame.id ? 'uppercase' : 'none',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                                }}>
                                    {selectedFrame === frame.id ? (
                                        <>
                                            <i className="fa fa-check-circle me-2"></i>Selected
                                        </>
                                    ) : (
                                        frame.platform
                                    )}
                                </div>

                                {/* Preview Image - Much Bigger */}
                                <div style={{
                                    width: '100%',
                                    height: '300px',
                                    overflow: 'hidden',
                                    background: '#f5f5f5'
                                }}>
                                    <img
                                        src={frame.preview}
                                        alt={frame.name}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            opacity: selectedFrame === frame.id ? 0.9 : 1,
                                            transition: 'opacity 0.3s ease'
                                        }}
                                    />
                                </div>

                                {/* Card Body */}
                                <div className="card-body" style={{ padding: '20px' }}>
                                    <h6 className="mb-2 font-weight-bold" style={{
                                        fontSize: '20px',
                                        color: selectedFrame === frame.id ? 'var(--themecolor)' : '#333'
                                    }}>
                                        {frame.name}
                                    </h6>
                                    <p className="text-muted mb-3" style={{ fontSize: '14px' }}>
                                        {frame.description}
                                    </p>

                                    {/* Select Button - Bigger */}
                                    <Button
                                        variant={selectedFrame === frame.id ? "success" : "primary"}
                                        className="w-100"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleSelectFrame(frame.id);
                                        }}
                                        style={{
                                            background: selectedFrame === frame.id ? '#28a745' : 'var(--themecolor)',
                                            border: 'none',
                                            fontWeight: '700',
                                            padding: '14px',
                                            borderRadius: '8px',
                                            fontSize: '15px'
                                        }}
                                    >
                                        {selectedFrame === frame.id ? (
                                            <>
                                                <i className="fa fa-check-circle me-2"></i>SELECTED
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-mouse-pointer me-2"></i>Select Frame
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Action Buttons */}
                <div className="d-flex justify-content-end gap-2 mt-4 pt-3" style={{ borderTop: '1px solid #f0f0f0' }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setSelectedFrame(null)}
                        disabled={!selectedFrame}
                        style={{
                            fontWeight: '600',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            fontSize: '15px'
                        }}
                    >
                        <i className="fa fa-times me-2"></i>Clear Selection
                    </Button>
                    <Button
                        variant="primary"
                        disabled={!selectedFrame}
                        style={{
                            background: 'var(--themecolor)',
                            border: 'none',
                            fontWeight: '600',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            fontSize: '15px'
                        }}
                    >
                        <i className="fa fa-check me-2"></i>Apply Frame
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SelectFrame;
